// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"f9c4d42e","82":"a8d76267","173":"27b467bf","548":"937fb42f","562":"7e29a1a3","566":"f864cb5c","568":"af9b485d","593":"bdc9a16d","683":"3f42e70b","717":"0c6665e2","722":"48e5a167","806":"8034f9a5"}[chunkId] + ".chunk.js";
};